
const teacherObj = [
  {
    id : 1,
    name : "Alisher Xazratov",
    group : [1],
    number : "(90) 212-22-15",
    groupNum : 1,
    status : "Muzlatilgan",
    payment : "100,000",
    img : "https://freepikpsd.com/file/2019/10/enseignant-png-3-Transparent-Images.png"
  },
  {
    id : 2,
    name : "Valibek Nasimov",
    group : [13, 14, 16],
    number : "(99) 654-45-21",
    groupNum : 3,
    status : "Aktiv",
    payment : "200,000",
    img : "https://cdn-icons-png.flaticon.com/512/183/183753.png"
  },
  {
    id : 3,
    name : "Karimberdi Aliyev",
    group : [17, 21],
    number : "(93) 305-85-59",
    groupNum : 2,
    status : "Aktiv",
    payment : "180,000",
    img : "https://cdn-icons-png.flaticon.com/512/247/247783.png"
  },
  {
    id : 4,
    name : "Elmurod Toshqulov",
    group : [22],
    number : "(90) 231-45-65",
    groupNum : 1,
    status : "Aktiv",
    payment : "180,000",
    img : "https://www.shareicon.net/data/512x512/2016/07/26/801997_user_512x512.png"
  },
  {
    id : 5,
    name : "Aleksandr Ivanov",
    group : [23],
    number : "(91) 319-18-91",
    groupNum : 1,
    status : "Muzlatilgan",
    payment : "13,000",
    img : "https://muast.ac.zw/wp-content/uploads/2019/02/fb517f8913bd99cd48ef00facb4a67c0-businessman-avatar-silhouette-by-vexels-1.png"
  }
];

export default teacherObj